import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';

import { NotificationService } from './notification.service';
import { UserNotificationsService } from './user-notifications.service';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
  ],
  providers: [
    NotificationService,
    UserNotificationsService
  ]
})
export class NotificationsModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/notifications/notifications.module.ts